import React from 'react';
import PropTypes from 'prop-types';
import { getImageUrl } from '../../utils';

import {
  Wrapper,
  NodeList,
  NodeListItem,
  HubImage,
  NoImage,
  HubName,
  Nodes,
  ListHeader,
  Indicators,
  Note,
  Accepted,
  RowWrapper,
} from './styles';

const AssignmentSection = ({ fileService, orderedHubs, navigationItems, isSession, nodeId }) => {
  const { items = [], neighbours = [] } = navigationItems;

  const gotoNode = (uuid) => {
    location.hash = `#${uuid}`;
  };

  const getNode = (uuid, type) => {
    return (type ? items : neighbours).find((item) => item.uuid === uuid);
  };

  const currentHub = orderedHubs.find((hub) => hub.uuid === nodeId);
  const neighbourIds = neighbours.map((node) => node.uuid);

  const renderNode = (node) => {
    const { uuid, name, image, type, notification, announcement, accepted, completed, lock_state } = getNode(
      node.uuid,
      node.type,
    );
    const imageUrl = getImageUrl(fileService, image, '56x56');
    const done = completed ? 'done' : '';
    const className = type ? `node ${type} ${done}` : `hub ${done} ${lock_state}`;
    const noteType = notification ? 'notification' : 'announcement';

    return (
      <React.Fragment key={uuid}>
        <NodeListItem className={className} onClick={() => gotoNode(uuid)}>
          <RowWrapper>
            <Wrapper>
              {!type && (imageUrl ? <HubImage src={imageUrl} /> : <NoImage />)}
              <HubName>{name}</HubName>
            </Wrapper>
            {isSession && (
              <Indicators>
                <Note show={notification || announcement} type={noteType} />
                <Accepted show={accepted} />
              </Indicators>
            )}
          </RowWrapper>
        </NodeListItem>
      </React.Fragment>
    );
  };

  return (
    <>
      {items?.length > 0 && (
        <Nodes>
          <ListHeader>{i18n.__('panel_nav_in_this_hub')}</ListHeader>
          <NodeList>{currentHub.nodes.map(renderNode)}</NodeList>
        </Nodes>
      )}
      {neighbours?.length > 0 && (
        <Nodes>
          <ListHeader>{i18n.__('panel_nav_more_hubs')}</ListHeader>
          <NodeList>{orderedHubs.filter((hub) => neighbourIds.includes(hub.uuid)).map(renderNode)}</NodeList>
        </Nodes>
      )}
    </>
  );
};

export default AssignmentSection;

AssignmentSection.propTypes = {
  fileService: PropTypes.object.isRequired,
  navigationItems: PropTypes.object.isRequired,
  orderedHubs: PropTypes.array.isRequired,
  isSession: PropTypes.bool.isRequired,
  nodeId: PropTypes.string.isRequired,
};
